import { Box, styled } from '@mui/material'
import { Store } from 'pullstate'
import { ReactNode } from 'react'
import BookletView from './BookletView'
import QuestionsPanel from './QuestionsPanel'

export const EvaluatorEditorLayout = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
}))

export interface BookletProps {
  bookletActions: ReactNode
  pdfUrl: string
}

export interface TableColumn {
  dataIndex: string
  key: string
  title: any
  render?: (cellData: any, row: any, index: number) => any
}

export type QuestionPaperPanelProps = {
  questionsPanelActions: ReactNode
  columns: Array<TableColumn>
  records: any[]
  handleRefresh: () => void
  evaluators: {
    evaluatorType: string
    obtainedMarks: number
    totalMarks: number
  }[]
}

export const EvaluatorEditorStore = new Store({
  panelOpen: true,
  hasReviewedAllPages: false,
  hasVisitedLastPage: false,
  zoomLevel: 1.8,
})

function EvaluatorEditor({
  bookletProps,
  questionPaperProps,
}: {
  bookletProps: BookletProps
  questionPaperProps: QuestionPaperPanelProps
}): JSX.Element {
  const { panelOpen, zoomLevel } = EvaluatorEditorStore.useState()
  const showPanel = panelOpen && zoomLevel <= 1.8

  return (
    <EvaluatorEditorLayout>
      {/* Booklet View */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <BookletView
          bookletActions={bookletProps.bookletActions}
          pdfUrl={bookletProps.pdfUrl}
        />
      </Box>
      {/* Question Paper Panel */}
      <Box
        sx={{
          width: panelOpen && zoomLevel <= 1.8 ? '520px' : '0px',
          overflow: 'hidden',
          transition: 'width 0.3s ease',
        }}
      >
        {showPanel ? (
          <QuestionsPanel questionPaperProps={questionPaperProps} />
        ) : null}
      </Box>
    </EvaluatorEditorLayout>
  )
}

export default EvaluatorEditor
